import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import Card from '../../card';
import Notification from '../../notification';
import AmenitiesViewContent from './amenities-view-content';
import AmenitiesEditModal from './amenities-edit-modal';
import StationPropType from '../../../utils/prop-types/station';
import { editStation } from '../../../actions';

const { api, logError } = require('../../../../lib/bputils').default;
const { canEditStationAmenities } = require('../../../../lib/permissions').default;

class StationAmenitiesCard extends React.Component {
  static propTypes = {
    dispatchEditStation: PropTypes.func,
    isLoading: PropTypes.bool,
    station: StationPropType,
  };

  static defaultProps = {
    dispatchEditStation: null,
    isLoading: false,
    station: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      allFeatures: [],
      features: props.station.features,
      isLoading: props.isLoading,
      stationSolutions: props.station.solutions,
      hasError: false,
    };
  }

  componentDidMount = async () => {
    try {
      const res = await api.get({
        path: '/features',
        requestId: 'stationFeaturesgetAllFeatures',
      });

      this.setState(() => ({ allFeatures: res }));
    } catch (err) {
      this.setState(() => ({ hasError: true }));
      logError(err);
    }
  };

  componentDidUpdate = (prevProps) => {
    const { station: { features, solutions: stationSolutions }, isLoading } = this.props;
    if (prevProps.isLoading !== isLoading
      || !_.isEqual(prevProps.station.features, features)) {
      this.setState(() => ({ isLoading, features, stationSolutions }));
    }
  }

  handleOnSave = (newFeatures) => {
    this.setState(() => ({ isLoading: true }));
    const { station: { id: stationId, emergency_status: emergencyStatus }, dispatchEditStation } = this.props;

    const featureIds = [].concat(newFeatures, (emergencyStatus || [])).map(sf => sf.id);

    api.put({
      path: `/stations/${stationId}/features`,
      data: {
        feature_ids: featureIds,
      },
    })
      .then(() => {
        dispatchEditStation({ features: newFeatures });
        Notification.success('Station amenities updated!');
        this.setState(() => ({ isLoading: false }));
      })
      .catch(() => Notification.error('There was an error updating station amenities. Please contact support.'));
  }

  getEditModal = () => {
    const { features, allFeatures, stationSolutions } = this.state;
    const { station: { address: { country } } } = this.props;

    if (!allFeatures.length) {
      return null;
    }

    return (
      <AmenitiesEditModal
        features={features}
        allFeatures={(allFeatures.find(af => af.country === country) || {}).features || []}
        stationSolutions={stationSolutions}
        onSave={this.handleOnSave}
      />
    );
  }

  render = () => {
    const { features, stationSolutions, hasError } = this.state;
    let { isLoading } = this.state;
    let editModal = null;
    const showEditButton = canEditStationAmenities();
    if (showEditButton) {
      editModal = this.getEditModal();
      // Following block can be moved to `Card` component once all cards are converted to new modal
      if (!editModal) {
        // show loading until edit modal is ready
        isLoading = true;
      }
    }

    return (
      <Card
        title="AMENITIES"
        showCollapseButton
        showEditButton={showEditButton}
        isLoading={isLoading}
        hasError={hasError}
        editModal={editModal}
      >
        <AmenitiesViewContent features={features} stationSolutions={stationSolutions} />
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
  isLoading: state.loading,
});

const mapDispatchToProps = dispatch => ({
  dispatchEditStation: stationEdit => dispatch(editStation(stationEdit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StationAmenitiesCard);
